/* import __COLOCATED_TEMPLATE__ from './categories-grid.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();